export default {
  urgency: {
    title: "Срочность",
    value: 0,
    variants: [
      { id: 0, title: "Стандартная", color: "green" },
      { id: 1, title: "Срочная", color: "red" },
    ],
  },
  multimodal: {
    title: "Мультимодальная",
    value: 0,
    variants: [
      { id: 0, title: "Нет", color: "green" },
      { id: 1, title: "Да", color: "red" },
    ],
    disabled: false,
  },
  invoice: {
    title: "Invoice",
    value: 2,
    variants: [
      { id: 1, title: "Есть", color: "green" },
      { id: 2, title: "Нет", color: "red" },
    ],
  },
  ex: {
    title: "EX",
    group: true,
    value: {
      exWhoDoing: {
        value: 2,
        variants: [
          { id: 2, title: "Делает фабрика" },
          { id: 3, title: "Без документов" },
          { id: 4, title: "Т1" },
          { id: 5, title: "По инвойсу" },
          { id: 6, title: "Делает экспедиция" },
          { id: 7, title: "Делает склад" },
          { id: 8, title: "Неизвестно" },
        ],
      },
      exDocumentInSystem: {
        value: 0,
        variants: [
          { id: 0, title: "Нет в системе", color: "red" },
          { id: 1, title: "Есть в системе", color: "green" },
        ],
      },
    },
  },
  description: {
    title: "Описание",
    value: 0,
    variants: [
      { id: 0, title: "Нет", color: "red" },
      { id: 1, title: "Есть", color: "green" },
      { id: 2, title: "В работе", color: "grey" },
      { id: 3, title: "Категории", color: "blue darken-1" },
    ],
    disabled: true,
  },
  damage: {
    title: "Повреждения",
    value: 0,
    variants: [
      { id: 0, title: "Нет", color: "green" },
      { id: 1, title: "Есть", color: "red" },
    ],
  },
  attention: {
    title: "Особое внимание",
    value: 0,
    variants: [
      { id: 0, title: "Нет", color: "green" },
      { id: 1, title: "Есть", color: "red" },
    ],
  },
  oversized: {
    title: "Негабарит",
    value: 0,
    variants: [
      { id: 0, title: "Нет", color: "green" },
      { id: 1, title: "Да", color: "red" },
    ],
    disabled: true,
  },
  fragile: {
    title: "Хрупкий",
    value: 0,
    variants: [
      { id: 0, title: "Нет", color: "green" },
      { id: 1, title: "Да", color: "red" },
    ],
    disabled: false,
    tooltip: "Изменение метки доступно из 'Описание товаров'",
  },
  mesurable: {
    title: "Обмер груза",
    value: 0,
    variants: [
      { id: 0, title: "Нет", color: "red" },
      { id: 1, title: "Поштучно", color: "green" },
      { id: 2, title: "Общий", color: "green" },
    ],
    disabled: false,
  },
  giveAway: {
    title: "Груз можно отгружать?",
    value: 1,
    variants: [
      { id: 0, title: "Нет", color: "red" },
      { id: 1, title: "Да", color: "green" },
    ],
  },
  cargoRepacked: {
    title: "Груз перепакован",
    value: 0,
    variants: [
      { id: 0, title: "Нет", color: "green" },
      { id: 1, title: "Да", color: "red" },
    ],
  },
  claim: {
    title: "Рекламация",
    value: 0,
    variants: [{ id: 0, title: "Нет" }, { id: 1, title: "Да", color: "red" }],
  },
  isPayed: {
    title: "Груз оплачен",
    value: 0,
    variants: [
      { id: 0, title: "Нет", color: "red" },
      { id: 1, title: "Да", color: "green" },
    ],
  },
  parseByOrders: {
    title: "Разобрать по ордерам",
    value: 0,
    variants: [
      { id: 0, title: "Нет", color: "red" },
      { id: 1, title: "Да", color: "green" },
    ],
  },
};
